import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import ProfessionalDetails from "./ProfessionalDetails";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class EditProfile extends Component {

validateForm(){
  return true;
}

constructor(props){
  super(props);

  this.state = {
      isPersonalDetailsLoading: false,
      dob: "",
      gender: "I",
      profilePic: ""

  };
}

handleChange = event => {
  this.setState({
    [event.target.id]: event.target.value
  });

}

handleFileChange = event => {
  this.file = event.target.files[0];
}

submitPersonalDetails = async event => {
    event.preventDefault();
    this.setState({ isPersonalDetailsLoading: true});
    var personalDetails = {};

    try{
      var isAnythingChanged = false;
      const attachments = [];
      if(this.file && this.file.size > config.MAX_ATTACHMENT_SIZE){
        alert("Please pick a profile pic smaller than 5MB");
        return;
      }

      if(this.file){
        isAnythingChanged = true;
        personalDetails.profilePic = await s3Upload(this.file);
      }
      if(this.state.dob && this.state.dob.length > 0){
        isAnythingChanged = true;
        personalDetails.dob = this.state.dob;
      }
      if(this.state.gender && this.state.gender.length > 0){
        isAnythingChanged = true;
        personalDetails.gender = this.state.gender;
      }

      if(this.state.phonenumber && this.state.phonenumber.length > 0){
        isAnythingChanged = true;
        personalDetails.phonenumber = this.state.phonenumber;
      }

      if(isAnythingChanged) {
          await this.createProfile(personalDetails);
      }
      this.setState({isPersonalDetailsLoading: false});
      this.props.history.push("/profile/edit");

    }catch(e){
      alert(e.message);
      this.setState({isPersonalDetailsLoading: false});
    }
 }

  createProfile(profileDetails){
    return API.put("retnetindia", "/user/profile", {
      body: profileDetails
    })
  }

render() {
    return(
      <div className="container">
            <br />
            <div className="row cols-xs-space cols-sm-space cols-md-space">
            <div className="col-lg-12">
                <div className="row">
                <div className="col-lg-4 profile-udpate-widget">
                  <div class="card">
                      <div class="card-title b-xs-bottom">
                          <h3 class="heading heading-sm text-uppercase">Personal Details</h3>

                      </div>
                      <div class="card-body">
                          <div class="row">
                              <div class="col-sm-12">
                                  <form id="personal-details-form"
                                      onSubmit={this.submitPersonalDetails}>
                                      <div className="form-group">
                                          <label for="phonenumber">Contact Number</label>
                                          <input type="number" id="phonenumber"
                                               className="form-control"
                                               placeholder=""
                                               onChange={this.handleChange} />
                                      </div>
                                      <div className="form-group">
                                          <label for="dob">Date Of Birth</label>
                                          <input type="date" id="dob"
                                               className="form-control"
                                               id="dob" placeholder=""
                                               onChange={this.handleChange} />
                                      </div>
                                      <div className="form-group">
                                          <label for="gender">Select Gender</label>
                                          <select className="form-control"
                                                  id="gender"
                                                  onChange={this.handleChange}>
                                              <option value="F">Female</option>
                                              <option value="M">Male</option>
                                              <option value="I">Ignore</option>
                                          </select>
                                      </div>
                                      <div className="form-group">
                                          <label for="profilePic">Profile Picture</label>
                                          <input type="file" name="profilePic"
                                                  id="profilePic"
                                                  onChange={this.handleFileChange} />
                                      </div>
                                      <br />
                                      <div className="form-group align-center">

                                          <LoaderButton block bsStyle="primary" bsSize="large"
                                                disable={!this.validateForm()} type="submit"
                                                isLoading={this.state.isPersonalDetailsLoading} text=" Update "
                                                loadingText="Updating Details..."
                                                className="btn btn-primary"/>
                                      </div>

                                  </form>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>

                <ProfessionalDetails />


                <div className="col-lg-4 profile-udpate-widget">
                  <div class="card">
                      <div class="card-title b-xs-bottom">
                          <h3 class="heading heading-sm text-uppercase">Update Education Details</h3>
                          <span href="#" class="btn-aux">

                          </span>
                      </div>
                      <div class="card-body">
                          <div class="row">
                              <div class="col-sm-12">
                                  <form id="personal-details-form">
                                      <div className="form-group">
                                          <label for="dob">Date Of Birth</label>
                                          <input type="date" className="form-control" id="dob" placeholder="" />
                                      </div>
                                      <div className="form-group">
                                          <label for="gender">Select Gender</label>
                                          <select className="form-control" id="feedsupdate">
                                              <option>Female</option>
                                              <option>Male</option>
                                              <option>Other</option>
                                          </select>
                                      </div>
                                      <div className="form-group">
                                          <label for="gender">Profile Picture</label>
                                          <input type="file" name="profile-pic" id="profile-pic" />
                                      </div>
                                      <br />
                                      <div className="form-group align-center">

                                          <LoaderButton block bsStyle="primary" bsSize="large"
                                                disable={!this.validateForm()} type="submit"
                                                isLoading={this.state.isLoading} text=" Update "
                                                loadingText="Updating Details..."
                                                className="btn btn-primary"/>
                                      </div>

                                  </form>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>

                </div>



              </div>






              <form >
                  <h3 className="heading heading-4 strong-700 mt-5 mb-4" id="ex_controls_examples">
                      Update Personal Details
                  </h3>
                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="firstname">First Name</label>
                              <input type="text" className="form-control" id="firstname" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="lastname">Last Name</label>
                              <input type="text" className="form-control" id="lastname" placeholder="" />
                          </div>

                      </div>

                  </div>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="email">Email Id (username)</label>
                              <input type="email" className="form-control" id="email" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="mobile">Mobile Number</label>
                              <input type="number" className="form-control" id="mobile" placeholder="" />
                          </div>
                      </div>

                  </div>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="password">Password</label>
                              <input type="password" className="form-control" id="password" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="confirmpwd">Confirm Password</label>
                              <input type="password" className="form-control" id="confirmpwd" placeholder="" />
                          </div>
                      </div>

                  </div>

                  <div className="form-group">
                      <label for="designation">Designation</label>
                      <input type="text" className="form-control" id="designation" placeholder="" />
                  </div>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="newsletter">Get News Letter</label>
                              <select className="form-control" id="newsletter">
                                  <option>Weekly</option>
                                  <option>Monthly</option>
                              </select>
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="feedsupdate">Get Feeds Update</label>
                              <select className="form-control" id="feedsupdate">
                                  <option>Yes</option>
                                  <option>No</option>
                              </select>
                          </div>
                      </div>

                  </div>

                  <h3 className="heading heading-4 strong-700 mt-5 mb-4" id="ex_controls_examples">
                      Profile Details
                  </h3>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="dob">Date Of Birth</label>
                              <input type="date" className="form-control" id="dob" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="gender">Select Gender</label>
                              <select className="form-control" id="feedsupdate">
                                  <option>Female</option>
                                  <option>Male</option>
                                  <option>Other</option>
                              </select>
                          </div>
                      </div>

                  </div>


                  <h3 className="heading heading-4 strong-700 mt-5 mb-4" id="ex_controls_examples">
                      Under Graduation
                  </h3>

                  <div className="form-group">
                      <label for="undergrad">*Under Graduation</label>
                      <input type="text" className="form-control" id="undergrad" placeholder="" />
                  </div>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="college">Institute Name</label>
                              <input type="text" className="form-control" id="college" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <div className="form-group">
                                  <label for="university">University Name</label>
                                  <input type="text" className="form-control" id="university" placeholder="" />
                              </div>
                          </div>
                      </div>

                  </div>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="city">City</label>
                              <input type="text" className="form-control" id="city" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <div className="form-group">
                                  <label for="state">State</label>
                                  <input type="text" className="form-control" id="state" placeholder="" />
                              </div>
                          </div>
                      </div>

                  </div>

                  <h3 className="heading heading-4 strong-700 mt-5 mb-4" id="ex_controls_examples">
                      Fellowhip
                  </h3>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="fellowship">Fellowship</label>
                              <input type="text" className="form-control" id="fellowship" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <div className="form-group">
                                  <label for="subspeciality">Select Sub Speciality</label>
                                  <select className="form-control" id="subspeciality">
                                      <option>Surgical Retina</option>
                                      <option>Medical Retina</option>
                                      <option>Uvea</option>
                                      <option>Ocular Oncology</option>
                                      <option>Neuro Opthalmology</option>
                                  </select>
                              </div>
                          </div>
                      </div>


                  </div>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="felloshipcollege">Institue Name</label>
                              <input type="text" className="form-control" id="felloshipcollege" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <div className="form-group">
                                  <label for="felloshipuniversity">University Name</label>
                                  <input type="text" className="form-control" id="felloshipuniversity" placeholder="" />
                              </div>
                          </div>
                      </div>

                  </div>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="fellowshipcity">City</label>
                              <input type="text" className="form-control" id="fellowshipcity" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <div className="form-group">
                                  <label for="fellowshipstate">State</label>
                                  <input type="text" className="form-control" id="fellowshipstate" placeholder="" />
                              </div>
                          </div>
                      </div>

                  </div>


                  <div className="form-group">
                      <label for="additionalqualification">Additional Qualification</label>
                      <input type="text" className="form-control" id="additionalqualification" placeholder="" />
                  </div>



                  <div className="form-group">
                      <label for="practicingaddress">Practicing Address</label>
                      <input type="text" className="form-control" id="practicingaddress" placeholder="" />
                  </div>


                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="experience">Years Of Experience</label>
                              <input type="number" className="form-control" id="experience" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <div className="form-group">
                                  <label for="phonenumber">Phone Number</label>
                                  <input type="text" className="form-control" id="phonenumber" placeholder="" />
                              </div>
                          </div>
                      </div>

                  </div>

                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label for="websiteurl">Website Url</label>
                              <input type="number" className="form-control" id="websiteurl" placeholder="" />
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <div className="form-group">
                                  <label for="pincode">Pincode</label>
                                  <input type="text" className="form-control" id="pincode" placeholder="" />
                              </div>
                          </div>
                      </div>

                  </div>

                  <h3 className="heading heading-4 strong-700 mt-5 mb-4" id="areasofinterest">
                      Areas Of Interest
                  </h3>

                  <div className="row">
                      <div className="col-md-4">
                          <div className="checkbox">
                              <input type="checkbox" name="vitreoretina" id="vitreoretina" />
                              <label for="vitreoretina">Vitreo Retina</label>
                          </div>
                      </div>
                      <div className="col-md-5">
                          <div className="checkbox">
                              <input type="checkbox" name="medicalretina" id="medicalretina" />
                              <label for="medicalretina">Medical Retina</label>
                          </div>
                      </div>
                      <div className="col-md-3">
                          <div className="checkbox">
                              <input type="checkbox" name="uvea" id="uvea" />
                              <label for="uvea">Uvea</label>
                          </div>
                      </div>
                  </div>

                  <div className="row">
                      <div className="col-md-4">
                          <div className="checkbox">
                              <input type="checkbox" name="ocularoncology" id="ocularoncology" />
                              <label for="ocularoncology">Ocular Oncology</label>
                          </div>
                      </div>
                      <div className="col-md-5">
                          <div className="checkbox">
                              <input type="checkbox" name="neuroopthalmology" id="neuroopthalmology" />
                              <label for="neuroopthalmology">Neuro Ophthalmology</label>
                          </div>
                      </div>
                      <div className="col-md-3">
                          <div className="checkbox">
                              <input type="checkbox" name="other" id="other" />
                              <label for="other">Other</label>
                          </div>
                      </div>
                  </div>

                  <h3 className="heading heading-4 strong-700 mt-5 mb-4" id="profilepicture">
                      Profile Picture
                  </h3>
                  <input type="file" id="profilepic" name="profilepic"  />
                  <br />
                  <hr />


                  <div className="checkbox" >
                      <input type="checkbox" name="accepttermsnconditions" id="accepttermsnconditions" />
                      <label for="accepttermsnconditions">I accept that the profile details can be shared with Retnet members, for online database.</label>
                  </div>


                  <div className="row">
                      <div className="col-md-5">

                      </div>
                      <div className="col-md-2">
                          <button className="btn btn-primary">Register Now</button>
                      </div>
                      <div className="col-md-5">

                      </div>
                  </div>

                  <br />


              </form>


       </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/EditProfile.js